import { Component, OnInit, HostListener, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PersonalInfo, ProformaInfo, QuotationDetail } from '../services/domain.service';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';
import { StudentType } from '../services/enums.service';
import { GlobalsService } from '../services/globals.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-personalinfo',
  templateUrl: './personalinfo.component.html',
  styleUrls: ['./personalinfo.component.less']
})

export class PersonalinfoComponent implements OnInit {
  labelFloat: string = "always";
  hideConfirmEmail: boolean = true;
  sendEmail: boolean = false;
  generateProforma: boolean = false;
  generateQuotation: boolean = false;

  confirmEmail: string = "";
  personalInfoForm: FormGroup;
  proformaForm: FormGroup;

  personalInfo: PersonalInfo = { initials: "", surname: "", email: "", sendEmail: false };

  proformaInfo: ProformaInfo = {companyName: "", contactPerson: "", contactNumber: "", companyRegNumber: "", 
    vatNumber: "", addressLine1: "", addressLine2: "", city: "", postalCode: "", country: ""};

    quotationDetail: QuotationDetail = { studentType: StudentType.local, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
    gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
    programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
    includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };

  constructor(private formBuilder: FormBuilder,
    private data: DataService,
    private router: Router,
    private globals: GlobalsService,
    private notifier: SnotifyService) { }

  ngOnInit() {
    if(window.innerWidth < 600) {
      this.labelFloat = "auto";
    }

    this.data.changePage("personalinfo");

    this.personalInfoForm = this.formBuilder.group({
      //Personal details controls
      initialsControl: new FormControl('', Validators.required),
      surnameControl: new FormControl('', Validators.required),
      emailAddressControl: new FormControl('', [Validators.required, Validators.email]),
      confirmEmailControl: new FormControl('', [Validators.required, Validators.email]),
      sendEmailControl: new FormControl(false)
    }, 
    {
      validator: this.confirmEmailMisMatch
    });

    this.proformaForm = this.formBuilder.group({
      //Proforma invoice details controls
      companyNameControl: new FormControl('', Validators.required),
      contactPersonControl: new FormControl('', Validators.required),
      contactNumberControl: new FormControl('', Validators.required),
      companyRegNumberControl: new FormControl(''),
      vatNumberControl: new FormControl(''),
      addressLine1Control: new FormControl('', Validators.required),
      addressLine2Control: new FormControl(''),
      cityControl: new FormControl(''),
      postalCodeControl: new FormControl('', Validators.required),
      countryControl: new FormControl('', Validators.required)
    });

    if(this.globals.quotationDetail){
      this.quotationDetail = this.globals.quotationDetail;

      if(this.quotationDetail.personalInfo){
        this.personalInfo = this.quotationDetail.personalInfo;
        this.sendEmail = this.quotationDetail.personalInfo.sendEmail;
        this.confirmEmail = this.quotationDetail.personalInfo.email;

        this.personalInfoForm.setValue({
          initialsControl: this.quotationDetail.personalInfo.initials,
          surnameControl: this.quotationDetail.personalInfo.surname,
          emailAddressControl: this.quotationDetail.personalInfo.email,
          confirmEmailControl: this.confirmEmail,
          sendEmailControl: this.quotationDetail.personalInfo.sendEmail
        });
      }

      this.generateQuotation = this.quotationDetail.generateQuotation;

      if(this.quotationDetail.proformaInfo){
        this.generateProforma = this.quotationDetail.generateProforma;
        this.proformaInfo = this.quotationDetail.proformaInfo;

        this.proformaForm.setValue({
          companyNameControl: this.quotationDetail.proformaInfo.companyName,
          contactPersonControl: this.quotationDetail.proformaInfo.contactPerson,
          contactNumberControl: this.quotationDetail.proformaInfo.contactNumber,
          companyRegNumberControl: this.quotationDetail.proformaInfo.companyRegNumber,
          vatNumberControl: this.quotationDetail.proformaInfo.vatNumber,
          addressLine1Control: this.quotationDetail.proformaInfo.addressLine1,
          addressLine2Control: this.quotationDetail.proformaInfo.addressLine2,
          cityControl: this.quotationDetail.proformaInfo.city,
          postalCodeControl: this.quotationDetail.proformaInfo.postalCode,
          countryControl: this.quotationDetail.proformaInfo.country
        });
      }
    }
  }

  confirmEmailMisMatch (fg: FormGroup){
    var emailAddress = fg.controls['emailAddressControl'];
    var emailConfirm = fg.controls['confirmEmailControl'];

   if(emailAddress.value != '' && emailConfirm.value != '' && emailAddress.value != emailConfirm.value){
     emailConfirm.setErrors({emailMismatch: true});
   }

    return null;
  }
  
  confirmEmailVisible() {
    this.hideConfirmEmail = false;
  }

  confirmEmailHidden() {
    this.hideConfirmEmail = true;
  }

  generateReport() {
    var btnPersonaInfo = document.getElementById('btnPersonaInfo');
    if(btnPersonaInfo){
      btnPersonaInfo.click();
    }

    if(this.generateProforma){
      var btnProformaInvoice = document.getElementById('btnProformaInvoice');
        if(btnProformaInvoice){
          btnProformaInvoice.click();
      }
    }

    if(this.personalInfoForm.valid){
      if(this.personalInfo.email != this.confirmEmail){
        this.notifier.warning('Email and Confirm Email do not match.', {
          timeout: 0,
          position: SnotifyPosition.centerCenter,
          closeOnClick: false,
          buttons: [
            {text: 'Ok'}
          ]
        });
        return;
      }

      if(this.generateQuotation == false && this.generateProforma == false){
        this.notifier.warning('You have to select at least one report type to generate.', {
          timeout: 0,
          position: SnotifyPosition.centerCenter,
          closeOnClick: false,
          buttons: [
            {text: 'Ok'}
          ]
        });
        return;
      }

      this.quotationDetail.personalInfo = this.personalInfo;
      this.quotationDetail.personalInfo.sendEmail = this.sendEmail;
      this.quotationDetail.generateQuotation = this.generateQuotation;
      this.quotationDetail.generateProforma = this.generateProforma;
      this.globals.quotationDetail = this.quotationDetail;
      
      if(!this.generateProforma){
        this.globals.quotationDetail.proformaInfo = undefined;

        this.router.navigate(['/default', {outlets: {'main': ['report']}}]);
      }
      else{
        if(this.proformaForm.valid){
          this.quotationDetail.proformaInfo = this.proformaInfo;

          this.router.navigate(['/default', {outlets: {'main': ['report']}}]);
        }
      }
    }
  }

  @HostListener('window:resize', ['$event']) 
  onResize(event){
    if(event.target.innerWidth < 600) {
      this.labelFloat = "auto";
    }
    else {
      this.labelFloat = "always";
    }
  }

  get initialsControl() { return this.personalInfoForm.get('initialsControl') };
  get surnameControl() { return this.personalInfoForm.get('surnameControl') };
  get emailAddressControl() { return this.personalInfoForm.get('emailAddressControl') };
  get confirmEmailControl() { return this.personalInfoForm.get('confirmEmailControl') };
  get sendEmailControl() { return this.personalInfoForm.get('sendEmailControl') };

  get companyNameControl() { return this.proformaForm.get('companyNameControl') };
  get contactPersonControl() { return this.proformaForm.get('contactPersonControl') };
  get companyRegNumberControl() { return this.proformaForm.get('companyRegNumberControl') };
  get contactNumberControl() { return this.proformaForm.get('contactNumberControl') };
  get vatNumberControl() { return this.proformaForm.get('vatNumberControl') };
  get addressLine1Control() { return this.proformaForm.get('addressLine1Control') };
  get addressLine2Control() { return this.proformaForm.get('addressLine2Control') };
  get cityControl() { return this.proformaForm.get('cityControl') };
  get postalCodeControl() { return this.proformaForm.get('postalCodeControl') };
  get countryControl() { return this.proformaForm.get('countryControl') };
}
